import $ from "jquery";

$(function () {
    // Slider doc: https://github.com/seiyria/bootstrap-slider
    $("#price_range").slider({
        tooltip_split: true
    });
});
